<template lang="pug">
.generic-wrapper
  .container
    BackButton(name="SettingsOverview")
    h1.title Mietobjekttypen
    .sub-headline Hier können Sie neue Mietobjekttypen anlegen oder verändern.

    b-message.margin-top(title="Sie sollten wissen, was Sie tun" type="is-danger" has-icon :closable="false")
      |Diese Einstellungen werden in der Regel einmalig oder in Absprache mit dem Systemadminstrator durchgeführt.
      br
      |Eine Veränderung der Daten kann zu unvorhergesehenen Effekten im System führen.

    .form-builder.margin-top
      b-tabs(type="is-boxed" position="is-centered")
        b-tab-item(label="Haupthaus" :icon="haupthausFormData.icon")
          FormBuilder(@add="(d) => addToLayout('Haupthaus', d)"
                      :columns="columns"
                      :layout="haupthausFormData.layout"
                      @remove="(idx) => removeFromLayout('Haupthaus', idx)"
                      @save="saveLayout('Haupthaus')")

        b-tab-item(label="Ferienhaus" :icon="ferienhausFormData.icon")
          FormBuilder(@add="(d) => addToLayout('Ferienhaus', d)"
                      :columns="columns"
                      :layout="ferienhausFormData.layout"
                      @remove="(idx) => removeFromLayout('Ferienhaus', idx)"
                      @save="saveLayout('Ferienhaus')")

        b-tab-item(label="Ferienwohnung" :icon="ferienwohnungFormData.icon")
          FormBuilder(@add="(d) => addToLayout('Ferienwohnung', d)"
                      :columns="columns"
                      :layout="ferienwohnungFormData.layout"
                      @remove="(idx) => removeFromLayout('Ferienwohnung', idx)"
                      @save="saveLayout('Ferienwohnung')")

        b-tab-item(label="Stellplatz" :icon="stellplatzFormData.icon")
          FormBuilder(@add="(d) => addToLayout('Stellplatz', d)"
                      :columns="columns"
                      :layout="stellplatzFormData.layout"
                      @remove="(idx) => removeFromLayout('Stellplatz', idx)"
                      @save="saveLayout('Stellplatz')")
            
</template>

<script>
import FormBuilder from "@/components/molecules/FormBuilder.vue";

export default {
  components: {
    FormBuilder
  },
  props: {
    id: {
      type: String
    }
  },
  data() {
    return {
      haupthausFormData: {
        name: "Haupthaus",
        icon: "home-city",
        layout: []
      },
      ferienhausFormData: {
        name: "Ferienhaus",
        icon: "home",
        layout: []
      },
      ferienwohnungFormData: {
        name: "Ferienwohnung",
        icon: "sofa",
        layout: []
      },
      stellplatzFormData: {
        name: "Stellplatz",
        icon: "parking",
        layout: []
      },
    };
  },
  computed: {
    columns() {
      return this.$store.state.rentObjectTypes.columns;
    }
  },
  methods: {
    addToLayout(type, d) {
      this[`${type.toLowerCase()}FormData`].layout.push(d);
    },
    removeFromLayout(type, idx) {
      this[`${type.toLowerCase()}FormData`].layout.splice(idx, 1);
    },
    saveLayout(type) {
      const data = {...this[`${type.toLowerCase()}FormData`]};

      if (data.id) {
        this.$store.dispatch("rentObjectTypes/update", data);
      } else {
        this.$store.dispatch("rentObjectTypes/create", data);
      }
    },
    async saveRentObjectType(m) {
      await this.$store.dispatch("rentObjectTypes/update", {
        id: this.id,
        formData: this.formData
      });
      if (m === "close") {
        this.$router.push({
          name: "SettingsRentObjectTypesList"
        });
      }
    }
  },
  async mounted() {
    this.$store.dispatch("rentObjectTypes/getColumns");
    await this.$store.dispatch("rentObjectTypes/findAll");
    this.haupthausFormData = this.$store.state.rentObjectTypes.all.find(r => r.name === "Haupthaus") || this.haupthausFormData;
    this.ferienhausFormData = this.$store.state.rentObjectTypes.all.find(r => r.name === "Ferienhaus") || this.ferienhausFormData;
    this.ferienwohnungFormData = this.$store.state.rentObjectTypes.all.find(r => r.name === "Ferienwohnung") || this.ferienwohnungFormData;
    this.stellplatzFormData = this.$store.state.rentObjectTypes.all.find(r => r.name === "Stellplatz") || this.stellplatzFormData;
    
    // Making sure that the Vuex state is not mutated
    this.haupthausFormData = JSON.parse ( JSON.stringify(this.haupthausFormData))
    this.ferienhausFormData = JSON.parse ( JSON.stringify(this.ferienhausFormData))
    this.ferienwohnungFormData = JSON.parse ( JSON.stringify(this.ferienwohnungFormData))
    this.ferienhausFormData = JSON.parse ( JSON.stringify(this.ferienhausFormData))
  }
};
</script>

<style lang="scss" scoped>
</style>